import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import { api } from '@/libs/baseApi.client';

/**
 * @description Интерфейс для запроса обновления Solana кошелька
 */
export interface UpdateSolanaWalletRequest {
  solanaAddress: string | null;
}
export interface UpdateSolanaWalletResponse {
  solanaAddress: string | null;
}

/**
 * @description Мутация для обновления Solana кошелька пользователя
 * @example
 * const mutation = useUpdateSolanaWalletMutation();
 * mutation.mutate({ solanaAddress: "9WzDXwBbmkg8ZTbNMqUxvQRAyrZzDsGYdLVL9zYtAWWM" });
 *
 * @returns {object} useMutation instance
 */
export const useUpdateSolanaWalletMutation = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
async function _temp(t0) {
  const {
    solanaAddress
  } = t0;
  const response = await api.post("/users/update-solana-wallet", {
    solanaAddress
  });
  return response.data;
}